import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigured = Boolean(url && anonKey);
let instance: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (!instance) {
    if (!url || !anonKey) throw new Error("Supabase não configurado.");
    instance = createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: "wesell-auth",
        flowType: "pkce",
      },
    });
  }
  return instance;
}
